<template>
    <div class="about">
        <div class="banner">
            <img src="../assets/images/img_banner_05.jpg"/>
            <div class="bannerText">
                <p class="wow animate__backInDown" data-wow-duration ="1.3s">关于我们</p>
                <p class="wow animate__backInDown" data-wow-duration ="1.3s">About Us</p>
            </div>
        </div>
        <div class="main warp wow animate__backInLeft" data-wow-duration ="1.5s">
           <p>
               汇法集团是国家首批综合信用服务机构，国家首批可为信用修复申请人出具信用修复报告的信用服务机构，是国家发展和改革委员会国家信息中心信用信息共享单位，社会信用体系建设成员单位，政府行政许可和行政处罚信息“双公示”第三方评估机构，是公共信用大数据领域引领者。
           </p>
        </div>
    </div>
</template>
<script>
import {WOW} from 'wowjs'
export default {
     mounted() {
          this.$nextTick(() => {
            let wow = new WOW({
                live:false
            })
            wow.init()
        })
    },
}
</script>
<style lang="less" scoped>
.about{
    width:100%;
    background: #fff;
    .banner{
        position: relative;
       .bannerText{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            p{
                color: #fff;
                font-size: 48px;
                text-align: center;
                &:last-child{
                   font-size: 36px;
                   margin-top: 18px;
                }
            }
       }
    }
    .main{
        margin: 0 auto;
        padding: 80px 0;
        padding-bottom: 228px;
        p{
            font-size: 28px;
            color: #666666;
            line-height: 54px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/about.vue